// @flow

import moment from 'moment';

import ApiObject from '../ApiObject';
import DateUtils from '../../utils/DateUtils';

/**
 * The settings allowing to calculate an adaptable delivery time settings.
 *
 * Calculation:
 * orderSettings.manufactureDelay + deliveryManArrivalDuration + deliveryTime
 */
export default class DeliveryAdaptableTimeSettings extends ApiObject {

  deliveryManArrivalDuration: MsTimestamp = DateUtils.MINUTE_AS_MS * 20;

  /**
  * must be calculate by the front. The distance time between the restaurant and the delivery
  * address.
  */
  // deliveryTime = 0;
  //

  getdeliveryManArrivalDurationAsMinutes(): number {
    return DateUtils.millisecondsToMinutes(this.deliveryManArrivalDuration);
  }

  setdeliveryManArrivalDurationFromMinutes(minutes: number) {
    this.deliveryManArrivalDuration = DateUtils.minutesToMilliseconds(minutes);
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/DeliveryAdaptableTimeSettings.js